// extracted by mini-css-extract-plugin
module.exports = {"sortable":"ListCore_sortable__MK5tq","icon":"ListCore_icon__Gm2qC","active":"ListCore_active__8FMxw"};